export enum UserPermission {
  EMPLOYEE = 'EMPLOYEE',
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
}
